<template>
    <div class="form-modal-attr-sku">
        <p class="alert alert-warning" v-if="products > 1">
            <i class="fa fa-exclamation-triangle"></i>
            Recuerda que estos ajustes se verán reflejados en <b>TODOS</b> los productos que selecciones
        </p>
        <h6 class="mb-3">
            Para activar <b>{{products > 1 ? 'los productos seleccionados' : 'el producto seleccionado'}}</b>, primero valide los siguientes datos:
        </h6>
        <b-row class="">
            <b-col xs="12" sm="12" md="12">
                <b-form-group horizontal label="% de Fee *" :invalid-feedback="!state.fee ? 'Ingrese un porcentaje': ''" :state="state.fee">
                    <b-form-input v-model="activeProduct.fee" placeholder="% de Fee" type="number"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="6" md="6" lg="6" xl="6" class="b-col-form pb-2">
                <b-form-group horizontal :label-cols="8" label="Vendible">
                    <c-switch 
                        inputType="checkbox" 
                        type="text" 
                        variant="success" 
                        on="Si" 
                        off="No" 
                        :pill="true" 
                        v-model="activeProduct.vendible" 
                        size="m" 
                        id="s0">
                    </c-switch>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="6" md="6" lg="6" xl="6" class="b-col-form">
                <b-form-group horizontal :label-cols="8" label="Comisionable">
                    <c-switch 
                        inputType="checkbox" 
                        type="text" 
                        variant="success" 
                        on="Si" 
                        off="No" 
                        :pill="true" 
                        v-model="activeProduct.comisionable" 
                        size="m" 
                        id="s0">
                    </c-switch>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="6" md="6" lg="6" xl="6" class="b-col-form">
                <b-form-group horizontal :label-cols="8" label="Inventariable">
                    <c-switch 
                        inputType="checkbox" 
                        type="text" 
                        variant="success" 
                        on="Si" 
                        off="No" 
                        :pill="true" 
                        v-model="activeProduct.inventariable" 
                        size="m" 
                        id="s0">
                    </c-switch>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="6" md="6" lg="6" xl="6" class="b-col-form">
                <b-form-group horizontal :label-cols="8" label="Marketplace">
                    <c-switch 
                        inputType="checkbox" 
                        type="text" 
                        variant="success" 
                        on="Si" 
                        off="No" 
                        :pill="true" 
                        v-model="activeProduct.marketplace" 
                        size="m" 
                        id="s0">
                    </c-switch>
                </b-form-group>
            </b-col>
        </b-form>
    </b-row>
    </div>
</template>

<script>
import {ValidationsMixim} from '@/mixims/ValidationsMixim.js'
import cSwitch from '@/components/common/Switch'
export default {
  components: {
    cSwitch
  },
  mixins: [ValidationsMixim],
  data () {
    return {
      activeProduct: {
        fee: 0,
        vendible: false,
        comisionable: false,
        inventariable: false,
        marketplace: false
      }
    }
  },
  props: {
    products: {
      type: Number,
      default: 1
    }
  },
  watch: {
    state () {
      this.activeProduct.fee = !isNaN(this.activeProduct.fee) ? parseInt(this.activeProduct.fee) : 0
      this.$emit('showbtns', {
        state: this.state.fee,
        data: this.activeProduct
      })
    },
    products () {
      this.activeProduct = {
        fee: 0,
        vendible: false,
        comisionable: false,
        inventariable: false,
        marketplace: false
      }
    }
  },
  computed: {
    state () {
      return {
        fee: this.activeProduct.fee >= 1, //  this.isValidInteger(this.percentageFee) &&
        vendible: this.activeProduct.vendible,
        comisionable: this.activeProduct.comisionable,
        inventariable: this.activeProduct.inventariable,
        marketplace: this.activeProduct.marketplace
      }
    }
  }
}
</script>


<style lang="scss">
.form-modal-attr-sku{
    padding:0px 15px;
    margin-bottom: 20px !important;
}
.b-col-form{
    .b-form-group.form-group{
        margin-bottom: 0px;
        .form-row{
            align-items: center;
            div[role="group"]{
                padding-top: 10px;
            }
        }
    }
}

@media only screen and (max-width: 599px) {
    .b-col-form{
        .b-form-group.form-group{
            .form-row{
                flex-wrap: nowrap !important;
                .col-form-legend{
                    width: 100% !important;
                }
                div[role="group"]{
                    width: 60px !important;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/FormActiveSku.vue